// extracted by mini-css-extract-plugin
export default {"SamplesPage":"SamplesPage_SamplesPage__N++iO"};